export default __webpack_public_path__ + "static/media/Together.e5d4fd40.svg";